import { render } from "./DailyPaymentsChart.vue?vue&type=template&id=72899573&ts=true"
import script from "./DailyPaymentsChart.vue?vue&type=script&lang=ts"
export * from "./DailyPaymentsChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__